// extracted by mini-css-extract-plugin
export var container = "_rr-0";
export var dotAnimation = "_rr-2";
export var dotsLoading = "_rr-1";